import { faqTitlesDict } from '@monoimin/intl';

import type { Locales } from '@monoimin/sb-types';

export const insertTitleFromBlok = (
  component: string | undefined,
  locale: Locales,
  title: string | null | undefined
) => {
  if (component === 'faq') {
    return title || faqTitlesDict[locale];
  }

  return title;
};
export default insertTitleFromBlok;
